import * as React from 'react';
import ReactModal from 'react-modal';
import ModalStyles from './Modal.styles';
const Modal = ({ children, isOpen, seamless = false, onAfterOpen, ...otherProps }) => {
    React.useEffect(() => {
        ReactModal.setAppElement('#root');
    }, []);
    return (React.createElement(ReactModal, { ...otherProps, isOpen: isOpen, className: "_", overlayClassName: "_", contentElement: (props, children) => (React.createElement(ModalStyles.Content, { ...props }, children)), overlayElement: (props, contentEl) => (React.createElement(ModalStyles.Overlay, { ...props, "data-seamless": seamless }, contentEl)), onAfterOpen: onAfterOpen }, children));
};
export default Modal;
